/**
 * stillwater — a calming space for people moving through a manic episode.
 * by David Hunt
 */
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { initAnalyticsIfOptedIn } from "@/lib/analytics";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register the offline service worker. Deliberately fire-and-forget: if the
// browser doesn't support SW or registration fails, the app still works — we
// just lose the offline layer. Never let SW issues break the calm experience.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      /* silent — no user-facing errors for background infrastructure */
    });
  });
}

// Analytics are OFF by default. This call is a no-op unless the user has
// previously flipped the About-panel telemetry toggle on. See analytics.js
// for the full opt-in flow and privacy posture.
initAnalyticsIfOptedIn();
